import axios from 'axios';
import proxy from './proxy';
import getConfluenceUrl from '../functions/getConfluenceUrl'

export const BASE_URL = getConfluenceUrl();

export default axios.create({
  baseURL: `${proxy}${BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});
